import { DESC } from 'config/constants';

export const usersConfig = [
  {
    name: 'checkbox',
    label: '',
    width: 40,
    type: 'checkbox',
  },
  {
    name: 'user_id',
    label: 'Id',
    width: 300,
    type: 'username',
  },
  {
    name: 'user_first_seen',
    label: 'First Seen',
    type: 'fromNow',
    width: 200,
  },
  {
    name: 'email',
    label: 'Email',
    width: 200,
  },
  {
    name: 'user_identity',
    label: 'Identity',
    width: 200,
  },
  {
    name: 'username',
    label: 'Username',
    width: 200,
  },
  {
    name: 'last_updated',
    label: 'Last Updated',
    type: 'fromNow',
    width: 200,
  },
];

export const EVENTS = {
  sessions: {
    name: 'Sessions',
    id: 'sessions',
    defaultSort: {
      order: DESC,
      field: 'session_time',
    },
  },
  pageviews: {
    name: 'Page Views',
    id: 'pageviews',
    defaultSort: {
      order: DESC,
      field: 'pageview_time',
    },
  },
  clicks: {
    name: 'Clicks',
    id: 'clicks',
  },
  form_interactions: {
    name: 'Form Interactions',
    id: 'form_interactions',
  },
};

export const defaultEvent = EVENTS.sessions;



// WEBPACK FOOTER //
// ./src/components/IterioApp/Users/Users.config.js